import React, { Component } from 'react';
import {  Button , Container , Dropdown , Header , Icon ,Input , Table } from 'semantic-ui-react'; 

import * as constantes from '../../constantes';
import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

const preguntasOption = [
    { key: '1', text: '1 - ¿De qué distrito judicial procede el expediente?', value: 1 },
    { key: '2', text: '2 - ¿Cuál es el Proceso Constitucional materia del Expediente?', value: 0  } 
]

const formularOption = [
    { key: '1', text: 'Coincidencia en texto de lista de items', value: 1 },
    { key: '2', text: 'Coincidencia en texto de opciones', value: 2 } 
]

export default class ConfigImp extends Component{

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,

            listaConfiguracion : null,
            activePage:1,
            totalPages:0,
            totalRows:0,
            begin: 0,
            end: 5
        };
  
        //this.onChange = this.onChange.bind(this);
        
    }
  
    componentDidMount() {

        auth0Client.isExpired();
        this.cargarListaPaginado( 1 );
        

    }

    agregarConfiguracion(){

    }

    eliminarConfiguracion(){

    }

    async cargarListaPaginado( paginaActiva ){
        let METHODNAME = 'cargarListaPaginado - ';
        console.log(METHODNAME + 'INI');
 
        let url = server+`/configImportacion`;
        
        let _rows = 10;
        let _begin = 0 ;
        let _end = _rows - 1;

        if( paginaActiva > 1 ){
            _begin = paginaActiva * _rows ;
            _end = _rows - 1; 
        }

        let dataForm = null;
        dataForm = {
            pagina : paginaActiva-1,
            filas : _rows
        }

        fetch( 
            url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then( (result) => {
                
                this.setState({
                    isLoaded: true,
                    listaConfiguracion: result.listaConfiguracion,
                    totalRows: result.cantidadRegistros,
                    activePage : paginaActiva, 
                    totalPages: result.totalPaginas,
                    begin: _begin,
                    end: _end
                });

            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');
    }

    render() {

        const { error, isLoaded , listaConfiguracion } = this.state;
    
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
    
            return(
                <Container>

                    <Header as='h2' content='Cargar valores del SIGE' className='h2' textAlign='center' />

                    <div>En esta pantalla se muestran las Preguntas que han sido configuradas para que se pre-carguen con los valores importados del SIGE</div>

                    <Table style={ { 'display' : 'none'}} celled>
                        <Table.Header>
                            <Table.Row key='head0001'>
                                <Table.HeaderCell width={4}>Campo BD</Table.HeaderCell> 
                                <Table.HeaderCell width={4}>Pregunta</Table.HeaderCell>
                                <Table.HeaderCell width={6}>Formula</Table.HeaderCell>
                                <Table.HeaderCell width={2}>Accion</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row key='001'>
                                <Table.Cell>
                                    <Input placeholder='campo de SIGE' name='campoSige' />
                                </Table.Cell> 
                                <Table.Cell>
                                    <Dropdown 
                                        id='cbPreguntas'
                                        name='cbPreguntas' 
                                        placeholder='-SELECCIONAR-'
                                        options={preguntasOption} 
                                        /> 
                                </Table.Cell>
                                <Table.Cell>
                                    <Dropdown 
                                        id='cbFormula'
                                        name='cbFormula' 
                                        placeholder='-SELECCIONAR-'
                                        options={formularOption} 
                                        /> 
                                </Table.Cell>
                                <Table.Cell>

                                </Table.Cell> 
                            </Table.Row>
                        </Table.Body>
                    </Table>

                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='3' textAlign='center'>
                                    Preguntas configuradas para cargar del SIGE
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row key='head0001'>
                            <Table.HeaderCell width={7}>Pregunta</Table.HeaderCell>
                                <Table.HeaderCell width={2}>Columna del SIGE</Table.HeaderCell> 
                                <Table.HeaderCell width={5}>Formula</Table.HeaderCell> 
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            { listaConfiguracion && listaConfiguracion.map(item => (
                            <Table.Row key={item.configImportacionId}> 
                                <Table.Cell>
                                    {item.pregunta.explicacionPregunta}
                                </Table.Cell>
                                <Table.Cell>
                                    {item.columna}
                                </Table.Cell> 
                                <Table.Cell>
                                    {item.configFormula.explicacion}
                                </Table.Cell>
                                
                            </Table.Row>
                             ))}
                             
                        </Table.Body>
                    </Table>

                </Container>
            );
    
            }
      }

  
}